import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=0871a4b2&scoped=true"
import script from "./topMenu.vue?vue&type=script&lang=js"
export * from "./topMenu.vue?vue&type=script&lang=js"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=0871a4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871a4b2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/topMenu.vue
// module id = null
// module chunks = 